// Selectors
const selectOrganisation = state => state.root.organisation;

export { selectOrganisation };
